import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './styles/globals.css';
import { ensureAnonymousAuth } from './lib/firebase';

// Firestore rules require an authenticated session (see firebase.ts).
// Fire-and-forget: subscriptions retry once the session lands.
void ensureAnonymousAuth().catch((err) =>
  console.error('anonymous auth failed — shop state will not load', err)
);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
